export default "__VITE_ASSET__CZ7PGkOE__"